import { UsersService } from "@/services/users";
import { EntitiesService } from "@/services/entity";

export const UsersMixin = {
  data() {
    return {
      suggestedSuffix: "(suggested)",
      members: [],
    };
  },
  computed: {
    selectedFinancialGroups() {
      return [];
    },
  },
  methods: {
    getSuggestedMemberStr(memberStr){
      return `${memberStr} ${this.suggestedSuffix}`
    },
    async getSuggestedMembers(entityCode = null, category = null) {
      if (!entityCode || !category) return [];
      const suggestedMembers = await EntitiesService.getSuggestedMembers(
        entityCode,
        category
      );
      return this.createMembersSelector(suggestedMembers);
    },
    isMemberAllowed(member) {
      if (typeof member === typeof "") return true;
      const hasRole =
        member.roles.includes("Admin") || member.roles.includes("Full scope");
      const hasFinancialRole = this.selectedFinancialGroups.length
        ? (member.financial_role || []).some((financialGroup) =>
            this.selectedFinancialGroups.includes(financialGroup)
          )
        : true;
      return hasRole || hasFinancialRole;
    },
    async populateMembers() {
      this.members = await UsersService.getUsers({ per_page: 2000 });
      return this.createMembersSelector(this.members);
    },
    createMembersSelector(members) {
      if (!members) return [];
      return members
        .filter((member) => {
          return this.isMemberAllowed(member);
        })
        .map(({email}) => {
          return {
            value: email,
            name: email,
            label: email,
          };
        });
    },
  },
};
